import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;

  if (!isAuthenticated && !isLoading)
    return (
      <Redirect
        to={{
          pathname: '/',
          // hash: 'login',
          state: { from: rest.location },
        }}
      />
    );
  return <Route render={(props) => <Component {...props} />} {...rest} />;
};

export default ProtectedRoute;
